<template>
    <div>
        <el-dialog align-center v-model="state.dialogVisible" :title="dialogTitle" width="800" draggable>
            <div class="userAdd_man">
                <el-form label-width="auto" :model="state.form" class="userFrom">
                    <el-col :span="12">
                        <el-form-item :label="t('attendanceDialog.signerName')">
                            <span>{{ state.form.real_name }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="t('field.mobile')">
                            <span>{{ state.form.mobile }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="t('attendanceDialog.signedAt')">
                            <span>{{ formatDisplayDateTime(state.form.signed_at) || '-' }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="t('attendance.latitude')">
                            <span>{{ state.form.latitude }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="t('attendanceDialog.signImage')">
                            <hc-oss-image-list :value="state.form.signature_image_url" />
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <template #footer>
                <el-button @click="state.dialogVisible = false">{{ t('improveDetail.close') }}</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { reactive, defineProps, defineExpose, computed } from "vue";
import { formatDisplayDateTime } from "@/utils/dateTime.js";
import { usePageI18n, t } from "@/composables/usePageI18n.js";

const props = defineProps({
    title: { type: String, default: '' },
});

const dialogTitle = computed(() => props.title || t('attendanceDialog.signDetailTitle'));

const state = reactive({
    dialogVisible: false,
    form: {},
});

const open = (row = {}) => {
    state.form = row?.id ? { ...row } : {};
    state.dialogVisible = true;
};

usePageI18n(() => {});

defineExpose({ open, state });
</script>

<style lang="less" scoped>
.userAdd_man {
    min-height: 200px;
    max-height: 600px;
    overflow: auto;
    padding: 0 30px;
}
.userFrom {
    display: grid;
    gap: 20px;
}
.record-img {
    width: 200px;
    height: 100px;
    border-radius: 6px;
    object-fit: cover;
}
</style>
